import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ClinicianHoursChart = () => {
    const waagData = useSelector((state) => state.waag.data);
    const loadingStatus = useSelector((state) => state.waag.status);
    const [clinicianMetrics, setClinicianMetrics] = useState([]);

    useEffect(() => {
        if (waagData?.clinicianHours) {
            // Create maps for each time period
            const thisWeekMap = new Map(waagData.clinicianHours.thisWeek.map(c =>
                [c._id.clinicianId, c.treatedHours]
            ));

            const lastWeekMap = new Map(waagData.clinicianHours.lastWeek.map(c =>
                [c._id.clinicianId, c.treatedHours]
            ));

            const thisMonthMap = new Map(waagData.clinicianHours.thisMonth.map(c =>
                [c._id.clinicianId, c.treatedHours]
            ));

            const lastMonthMap = new Map(waagData.clinicianHours.lastMonth.map(c =>
                [c._id.clinicianId, c.treatedHours]
            ));

            // Transform data for each clinician
            const transformedMetrics = waagData.clinicianHours.last52Weeks.map((clinician) => ({
                name: `${clinician._id.firstName} ${clinician._id.lastName}`,
                thisWeek: thisWeekMap.get(clinician._id.clinicianId)?.toFixed(1) || "0",
                lastWeek: lastWeekMap.get(clinician._id.clinicianId)?.toFixed(1) || "0",
                mtd: thisMonthMap.get(clinician._id.clinicianId)?.toFixed(1) || "0",
                lastMonth: lastMonthMap.get(clinician._id.clinicianId)?.toFixed(1) || "0",
                target: "40",
                percentCurr: thisMonthMap.get(clinician._id.clinicianId)
                    ? `${((thisMonthMap.get(clinician._id.clinicianId) / 160) * 100).toFixed(0)}%`
                    : "N/A",
                percentLast: lastMonthMap.get(clinician._id.clinicianId)
                    ? `${((lastMonthMap.get(clinician._id.clinicianId) / 160) * 100).toFixed(0)}%`
                    : "N/A"
            }));

            setClinicianMetrics(transformedMetrics);
        }
    }, [waagData]);

    return (
        <div className="mt-6 relative">
            {loadingStatus === 'loading' && (
                <div className="absolute inset-0 bg-white/50 backdrop-blur-sm flex items-center justify-center z-10">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                </div>
            )}
            <div className="bg-white border rounded-sm shadow-sm">
                <div className="px-4 h-14 flex items-center border-b">
                    <h3 className="text-base font-semibold text-gray-900">
                        Clinician Hours
                    </h3>
                </div>
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="border-b bg-gray-50/50">
                                <th className="px-4 h-10 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    Clinician
                                </th>
                                <th className="px-4 h-10 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    This Week
                                </th>
                                <th className="px-4 h-10 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    Last Week
                                </th>
                                <th className="px-4 h-10 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    MTD
                                </th>
                                <th className="px-4 h-10 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    Last Month
                                </th>
                                <th className="px-4 h-10 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    Target
                                </th>
                                <th className="px-4 h-10 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    % curr
                                </th>
                                <th className="px-4 h-10 text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    % last
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {clinicianMetrics.map((metric) => (
                                <tr key={metric.name} className="border-b last:border-0 hover:bg-gray-50/50 transition-colors">
                                    <td className="px-4 h-10 text-sm font-medium text-gray-900">
                                        {metric.name}
                                    </td>
                                    <td className="px-4 h-10 text-sm text-gray-600">
                                        {metric.thisWeek}
                                    </td>
                                    <td className="px-4 h-10 text-sm text-gray-600">
                                        {metric.lastWeek}
                                    </td>
                                    <td className="px-4 h-10 text-sm text-gray-600">
                                        {metric.mtd}
                                    </td>
                                    <td className="px-4 h-10 text-sm text-gray-600">
                                        {metric.lastMonth}
                                    </td>
                                    <td className="px-4 h-10 text-sm text-gray-600">
                                        {metric.target}
                                    </td>
                                    <td className="px-4 h-10 text-sm text-gray-600">
                                        {metric.percentCurr}
                                    </td>
                                    <td className="px-4 h-10 text-sm text-gray-600">
                                        {metric.percentLast}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ClinicianHoursChart;
